import { useDirection, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Card, Inline, Stack, vars } from '@etg/wings';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { AgeType } from '@eti/schema-types';
import { PERSONAL_ITEM } from '../constants';
import BaggageStatus from '../../common/components/BaggageStatus';
import BaggageSectionDescription from '../../common/components/BaggageSectionDescription';
import BaggageSectionHeader from '../../common/components/BaggageSectionHeader';
import BaggageIllustration from '../../common/components/BaggageIllustration';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const personalItemCardWrapperStyles = css`
  border: 1px solid ${vars.colors.divider};
  display: flex;
  flex-direction: column;
  margin-block-end: 16px;
`;
const PersonalItem = ({
  ageType,
  personalItemTripSummary,
  travelerId
}) => {
  var _personalItemTraveler, _personalItemTraveler2;
  const {
    t
  } = useTranslation();
  const {
    isRTL
  } = useDirection();
  const productName = PERSONAL_ITEM.name;
  const personalItemTitle = t('Cart.PersonalItem.Title');
  const personalItemDescription = t('TravelerForm.PersonalItem.Description.Label');
  const personalItemIncludedStatusLabel = t('TravelerDetails.Status.Included');
  const personalItemNotIncludedStatusLabel = t('TravelerDetails.Status.Unavailable');
  const {
    personalItemTravelerDetails
  } = personalItemTripSummary || {};
  const personalItemDetails = (_personalItemTraveler = personalItemTravelerDetails === null || personalItemTravelerDetails === void 0 || (_personalItemTraveler2 = personalItemTravelerDetails[0]) === null || _personalItemTraveler2 === void 0 ? void 0 : _personalItemTraveler2.personalItemDetails) !== null && _personalItemTraveler !== void 0 ? _personalItemTraveler : {};
  const isPersonalItemIncluded = !personalItemTravelerDetails.filter(personalItem => personalItem !== null).some(personalItem => (personalItem === null || personalItem === void 0 ? void 0 : personalItem.personalItemStatus) === 'NO_PERSONAL_ITEM');
  const showPersonalItem = ageType !== AgeType.Inf && (isPersonalItemIncluded || Object.keys(personalItemDetails).length);
  return showPersonalItem ? /*#__PURE__*/_jsx(Card, {
    className: personalItemCardWrapperStyles,
    "data-testid": "personalItem",
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 16,
      children: [/*#__PURE__*/_jsxs(Stack, {
        spacing: 8,
        children: [/*#__PURE__*/_jsx(BaggageSectionHeader, {
          productName: productName,
          title: personalItemTitle,
          travelerId: travelerId
        }), /*#__PURE__*/_jsx(BaggageSectionDescription, {
          description: personalItemDescription,
          productName: productName,
          travelerId: travelerId
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        children: [/*#__PURE__*/_jsx(BaggageIllustration, {
          isRTL: isRTL,
          productName: productName
        }), isPersonalItemIncluded ? /*#__PURE__*/_jsx(BaggageStatus, {
          dataTestId: "includedBaggage-status",
          statusLabel: personalItemIncludedStatusLabel,
          variant: "positive"
        }) : /*#__PURE__*/_jsx(BaggageStatus, {
          dataTestId: "notAvailableBaggage-status",
          statusLabel: personalItemNotIncludedStatusLabel,
          variant: "caution"
        })]
      })]
    })
  }) : null;
};
export default PersonalItem;
//# sourceMappingURL=PersonalItem.js.map